import React, { useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './Introduction.css'
import GetCourseInfo from "../hooks/getCourseInfo.js";

import Loading from './Loading.js';
import Error from "./Error.js";
import VideoModal from "../components/universal/VideoModal/VideoModal.js";
import Project from "../components/pages/introduction/Project.js";

const parse = require('html-react-parser');
const DOMPurify = require('dompurify');

function Introduction() {
    const navigate = useNavigate();
    const params = useParams();
    const [showVideo, setShowVideo] = useState(false);

    const level_number = params.levelNumber;
    const course = params.course;

    // Fetch course data
    const {
        class_project_title,
        challenge_project_title,
        level_topics,
        class_project_description,
        challenge_project_description,
        class_project_replit_link,
        challenge_project_replit_link,
        level_description,
        video_link,
        capstone_code,
        loading
    } = GetCourseInfo(course, level_number);

    const clean_level_topics = DOMPurify.sanitize(level_topics, { ALLOWED_ATTR: ['style', 'class', 'className'] });
    let error = false;

    if (!loading && !level_description.length) {
        error = true;
    }

    if (loading) return <Loading />;
    if (error) return <Error />;

    // Set course display name dynamically
    const courseDisplayName = course === "python" 
        ? "Python" 
        : course === "python-legacy"
            ? "Python Legacy"
            : course === "web-development"
                ? "Web Development"
                : course === "apis-with-python"
                    ? "APIs with Python"
                    : "Course";

    return (
        <div>
            <Helmet>
                <title>{courseDisplayName} Level {level_number} | Mission Encodeable</title>
                <meta name="description" content={`An introduction to ${courseDisplayName} Level ${level_number}.`} />
            </Helmet>

            <section>
                <div className="wrapper">
                    <div className="top-section">
                        <h1>{courseDisplayName} Level {level_number}</h1>
                        <h3>{level_description}</h3>
                    </div>

                    <div className="float-wrapper">
                        <div className="float-or-inline-if-narrow">
                            <div className="top-section-image-and-video">
                                <div className="introduction-card-featured-top-section topics-box-top-section">
                                    {video_link === null
                                        ? <h3>Level {level_number}</h3>
                                        : <img
                                            src={`../../introduction_thumbnails/${course}-level-${level_number}-video-thumbnail.webp`}
                                            className='level_topics_image'
                                            onClick={() => setShowVideo(true)}
                                            alt={`Level ${level_number} thumbnail`}
                                        />}
                                </div>
                            </div>

                            <div className='level_topics_info'>
                                <button onClick={() => navigate(`/${course}/level/${level_number}/step/1`)} className="btn_orange_fill high">Start level</button>
                                <h4>What you'll learn</h4>
                                <div className="level_topics_wrapper">{parse(`${clean_level_topics}`)}</div>
                                <button onClick={() => navigate(`/${course}/level/${level_number}/step/1`)} className="btn_orange_fill low">Start level</button>
                            </div>
                        </div>
                    </div>

                    <div className="bottom-section">

                        { course !== "apis-with-python" && <h3 className="darkgreen">{course !== "python-legacy" ? "Capstone Project" : "The projects"}</h3>}
                        { course !== "apis-with-python" && <p>The Capstone Project is what you'll have gained the skills to create on your own at the end of this level. </p>}
                        
                        <div className='projects'>
                            <Project title={class_project_title} description={class_project_description} replit_link={class_project_replit_link} project_code={capstone_code}/>
                            <Project title={challenge_project_title} description={challenge_project_description} replit_link={challenge_project_replit_link} />
                        </div>
                    </div>
                </div>

                <div className="start-section">
                    <h2>Ready to start {courseDisplayName} Level {level_number}?</h2>
                    <button onClick={() => navigate(`/${course}/level/${level_number}/step/1`)} className="btn_green_outline">Start level</button>
                </div>
            </section>

            <VideoModal onClose={() => setShowVideo(false)} showVideo={showVideo} videoLink={video_link} />
        </div>
    );
}

export default Introduction;
